import React from 'react'
import { Currencies } from '../../helpers/currency/getCurrencySymbol'
import floorFigure from '../configs/helpers/floorFigure'
import { BalanceWrapper } from './BalanceStyles'
import { Balance_props } from './interface'

function Balance({ balance, currency }: Balance_props) {
  return (
    <BalanceWrapper>
      <span>
        Balance: {Currencies[currency] && Currencies[currency].symbol}
        {floorFigure(
          balance,
          Currencies[currency] ? Currencies[currency].precision : 2,
        )}
      </span>
      <span>cyberdice</span>
    </BalanceWrapper>
  )
}
export default Balance
